import { downloadLogEntries } from '@monorepo/shared/apiClient/logs';
import { useToast } from '@monorepo/shared/contexts';
import { useDateRangeFilter } from '@monorepo/shared/hooks/useDateRangeFilter';
import { NullableDate, UTCEquivalentOfLocal } from 'mapistry-shared';
import React, { useCallback } from 'react';
import { Form } from 'react-final-form';
import { LogEntryExportModalContent } from './LogEntryExportForm';

export type LogEntryExportFormValues = {
  from: NullableDate;
  to: NullableDate;
};

export type LogEntryExportModalProps = {
  logId: string;
  onClose: () => void;
  open: boolean;
  organizationId: string;
  projectId: string;
};

export function LogEntryExportModal({
  logId,
  onClose,
  open,
  organizationId,
  projectId,
}: LogEntryExportModalProps) {
  const { filter } = useDateRangeFilter();
  const { showUserFriendlyErrorToast } = useToast();

  const onSubmit = useCallback(
    (values: LogEntryExportFormValues) => {
      try {
        downloadLogEntries({
          logId,
          organizationId,
          projectId,
          after: values.from ? UTCEquivalentOfLocal(values.from) : undefined,
          before: values.to ? UTCEquivalentOfLocal(values.to) : undefined,
        });
        onClose();
      } catch (error) {
        showUserFriendlyErrorToast(error, 'Unable to process data for export.');
      }
    },
    [logId, onClose, organizationId, projectId, showUserFriendlyErrorToast],
  );

  return (
    <Form<LogEntryExportFormValues>
      onSubmit={onSubmit}
      initialValues={{ from: filter?.from ?? null, to: filter?.to ?? null }}
      subscription={{}}
    >
      {({ handleSubmit }) => (
        <LogEntryExportModalContent
          handleSubmit={handleSubmit}
          logId={logId}
          onClose={onClose}
          open={open}
          organizationId={organizationId}
          projectId={projectId}
        />
      )}
    </Form>
  );
}
